<template>

  <date-picker 
    type="date"
    :value="transformData"
    range
    @change="change"
    :shortcuts="shortcuts"
    :lang="lang"
    :width="'100%'"
    :format="format">
    </date-picker>

</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
  name: 'RangeDate',
  components: {
    DatePicker
  },
  props: [
    'value'
  ],
  data () {
    return {
      lang: this.$i18n.locale.toLowerCase(),
      format: this.$t('date_format'),
      shortcuts: [
        {
          text: 'Hoje',
          onClick: () => {
            this.change([
              moment().startOf('day'),
              moment().endOf('day')
            ])
          }
        },
        {
          text: 'Ontem',
          onClick: () => {
            this.change([
              moment().subtract(1, 'days').startOf('day'),
              moment().subtract(1, 'days').endOf('day')
            ])
          }
        },
        {
          text: 'Esta semana',
          onClick: () => {
            this.change([
              moment().startOf('week'),
              moment().endOf('week')
            ])
          }
        },
        {
          text: 'Semana passada',
          onClick: () => {
            this.change([
              moment().subtract(1, 'week').startOf('week'),
              moment().subtract(1, 'week').endOf('week')
            ])
          }
        },
        {
          text: 'Últimos 7 dias',
          onClick: () => {
            this.change([
              moment().subtract(7, 'days').startOf('day'),
              moment().subtract(2, 'days').endOf('day')
            ])
          }
        },
        {
          text: 'Este mês',
          onClick: () => {
            this.change([
              moment().startOf('month'),
              moment().endOf('month')
            ])
          }
        },
        {
          text: 'Mês passado',
          onClick: () => {
            this.change([
              moment().subtract(1, 'month').startOf('month'),
              moment().subtract(1, 'month').endOf('month')
            ])
          }
        },
        {
          text: 'Útimos 30 dias',
          onClick: () => {
            this.change([
              moment().subtract(30, 'days').startOf('day'),
              moment().subtract(2, 'days').endOf('day')
            ])
          }
        },
        {
          text: 'Este ano',
          onClick: () => {
            this.change([
              moment().startOf('year'),
              moment().endOf('year')
            ])
          }
        },
        {
          text: 'Ano passado',
          onClick: () => {
            this.change([
              moment().subtract(1, 'year').startOf('year'),
              moment().subtract(1, 'year').endOf('year')
            ])
          }
        },
        {
          text: 'Últimos 12 meses',
          onClick: () => {
            this.change([
              moment().subtract(12, 'month').startOf('month'),
              moment().subtract(1, 'month').endOf('month')
            ])
          }
        },
        {
          text: 'Todo período',
          onClick: () => {
            this.change(null)
          }
        }
      ]
    }
  },
  computed: {
    transformData () {
      if (this.value) {
        return [
          moment(this.value[0]).toISOString(),
          moment(this.value[1]).subtract(12, 'hours').toISOString() // corrige posição da seleção
        ]
      } else {
        return null
      }
    }
  },
  mounted () {
  },
  methods: {
    change (value) {
      if (value && value[0] && value[1]) {
        const a = [
          moment(value[0]).startOf('day').toISOString(),
          moment(value[1]).endOf('day').toISOString()
        ]
        // console.log(a)
        this.$emit('input', a)
      } else {
        this.$emit('input', null)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/RangeDate.vue